// ------------------------------------
// Actions
// ------------------------------------

import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser
} from 'amazon-cognito-identity-js'

import config from '../../../config/cognito'

export function login (email, password) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  })
  const user = new CognitoUser({ Username: email, Pool: userPool })
  const authenticationData = { Username: email, Password: password }
  const authenticationDetails = new AuthenticationDetails(authenticationData)
  user.authenticateUser(authenticationDetails, {
    onSuccess: result => console.dir(result),
    onFailure: err => console.dir(err)

  })
}

export const actions = {
  login
}

const initialState = { authenticated: false }
export default function loginReducer (state = initialState, action) {
  switch (action.type) {
    case 'LOGIN':
      return { isLoading: true, hasLoaded: false, error: null, authenticated: false }
    case 'LOGIN_SUCCESS':
      return { isLoading: false, hasLoaded: true, error: null, authenticated: action.payload }
    case 'LOGIN_FAIL':
      return { isLoading: false, hasLoaded: true, events: [], error: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/Login/modules/login.js